<template>
  <div v-if="errorCount > 0">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="300"
      offset-x
    >
      <v-btn slot="activator" @click="menu= true" icon class="ml-0">
        <v-badge overlap color="error">
          <span slot="badge">{{errorCount}}</span>
          <v-icon color="red" size="28">
            error
          </v-icon>
        </v-badge>
      </v-btn>
      <v-card>
        <v-list subheader :dense="true" style="max-width:500px!important">
          <template v-for="(emailList, index) in errorList">
            <v-divider v-if="index != 0" :key="`di`+index"></v-divider>
              <v-list-tile avatar :key="`icon`+index" :style="'height:35px;'">
              <v-list-tile-content>
                <v-list-tile-title class="subheading d-inline-block"><v-icon size="20" :color="(emailList.isStopped) ? `error` : `warning`" class="mr-1">error</v-icon> {{emailList.emailId}}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action style="min-width:120px!important;">
                <p class="mb-0 text-xs-right" style="width:100%">{{emailList.lastReadDateTime | timeAgoFilter}}</p>
              </v-list-tile-action>
            </v-list-tile>
            <div style="margin-left:33px;white-space: pre-wrap" v-if="emailList.isStopped" class="pl-0" :key="`info`+index">
              <p class="error--text subheading mb-0">System stopped reading email for {{emailList.emailId}} after {{emailList.emailReadErrList.length}} consecutive failed attempts (errors returned by your email server is listed below). To resume reading email you will have to check with your email service provider by sharing below errors OR in case there is any configuration/password change you will have to modify email configuration, <a @click="openConfigPage(emailList.emailConfigId)">click here</a> to view/update the configuration</p>
            </div>
            <div style="margin-left:33px;white-space: pre-wrap" v-if="emailList.isDelayRead" class="pl-0" :key="`info`+index">
              <p class="warning--text subheading mb-0">While reading {{emailList.emailId}} system have encountered below errors, system will retry email reading again around {{emailList.emailReadErrList[emailList.emailReadErrList.length - 1].retryTime | dateTimeFilter}}</p>
            </div>
            <div style="margin-left:33px" :key="`expand`+index">
              <p class="mb-0 subheading font-weight-medium">Errors returned by your email server:</p>
            </div>
            <div style="margin-left:38px" v-for="(errorList, Eindex) in emailList.emailReadErrList" :key="Eindex">
              <v-divider v-if="Eindex != 0" :key="`die`+index"></v-divider>
              <p class="mb-0 subheading font-weight-medium">Failed at: {{errorList.addedDate | dateTimeFilter}}</p>
              <p class="mb-0">{{errorList.errorMessage}}</p>
            </div>
          </template>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="menu = false">Close</v-btn>
          <v-btn color="primary" flat @click="markAllAsRead()">mark all as read</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import Crm from '@/api/Crm'
export default {
  data () {
    return {
      errorCount: 0,
      errorList: [],
      menu: false
    }
  },
  mounted () {
    this.loadErrorList()
  },
  methods: {
    loadErrorList () {
      Crm.EmailReadErrorList(
        response => {
          this.errorCount = 0
          this.errorList = []
          for (let index = 0; index < response.Data.emailFailedList.length; index++) {
            let emailDetail = response.Data.emailFailedList[index]
            console.log('emailDetail', emailDetail)
            let isPushInArr = true
            if (emailDetail.emailReadErrList !== null) {
              for (let j = 0; j < emailDetail.emailReadErrList.length; j++) {
                if (emailDetail.emailReadErrList[j].markAsRead === true) {
                  isPushInArr = false
                } else {
                  this.errorCount++
                }
              }
            }
            if (isPushInArr === true) {
              this.errorList.push(emailDetail)
            }
          }
          console.log('email err res', response)
        },
        error => {
          console.log('error msg', error)
        }
      )
    },
    markAllAsRead () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Please wait..'})
      Crm.MarkAsReadEmailReadError(
        response => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.menu = false
          this.loadErrorList()
        },
        error => {
          console.log('error msg', error)
        }
      )
    },
    openConfigPage (value) {
      this.$router.push({name: 'emailConfigurationDetail', params: {emailConfigId: value}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/admin/layout/components/errorList.vue